import BaseEnumType from "../../common/base-enum-type";

const PatResultType = Object.freeze({
    GOOD: new BaseEnumType("G", "GOOD"),
    MISSED: new BaseEnumType("M", "MISSED"),
    BLOCKED: new BaseEnumType("B", "BLOCKED"),
    FUMBLED: new BaseEnumType("F", "FUMBLED"),
    INTERCEPTED: new BaseEnumType("X", "INTERCEPTED")
});

export default PatResultType;
